import { DASHBOARD_LITE_MODELS_ACTION_TYPES } from '@constants/actionTypes/dashboardLiteActionTypes';

const INITIAL_STATE = {
    isLoading: false,
    entities: [],
    error: null
};

export default (state=INITIAL_STATE, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case (DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_START):
            return {
                ...state,
                isLoading: true
            };

        case (DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_SUCCESS):
            return {
                ...state,
                isLoading: false,
                entities: payload
            };

        case (DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_FAIL):
            return {
                ...state,
                isLoading: false,
                error: payload
            };
        default:
            return state;
    }
};